"use client";

import {
  TooltipProvider,
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  Toggle,
} from "@oreme/ui";
import { useAtom } from "jotai";
import { SlidersHorizontal, HelpCircleIcon } from "lucide-react";
import { useRControl } from "maplibre-react-components";
import { useTranslations } from "next-intl";
import React, { type ReactElement } from "react";
import { createPortal } from "react-dom";
import { settingsVisibilityAtom, tourVisibilityAtom } from "@/store/sites";

function SitesControlRight(): ReactElement | null {
  const { container } = useRControl({
    position: "top-right",
  });
  const t = useTranslations("sites.ControlRight");
  const [isSettingsVisible, setSettingsVisibility] = useAtom(
    settingsVisibilityAtom,
  );
  const [isTourVisible, setTourVisibility] = useAtom(tourVisibilityAtom);

  return createPortal(
    <>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <span className="rounded-sm overflow-hidden">
              <Toggle
                pressed={isSettingsVisible}
                onPressedChange={setSettingsVisibility}
                className="block p-0 m-0 min-w-auto data-[state=on]:bg-accent!"
              >
                <SlidersHorizontal strokeWidth={1} />
              </Toggle>
            </span>
          </TooltipTrigger>
          <TooltipContent side="left">
            <p className="p-0 m-0">{t("configureMap")}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <span className="rounded-sm overflow-hidden">
              <Toggle
                pressed={isTourVisible}
                onPressedChange={setTourVisibility}
                className="block p-0 m-0 min-w-auto data-[state=on]:bg-accent!"
                id="tour-7"
              >
                <HelpCircleIcon strokeWidth={1} />
              </Toggle>
            </span>
          </TooltipTrigger>
          <TooltipContent side="left">
            <p className="p-0 m-0">{t("help")}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </>,
    container,
  );
}

export { SitesControlRight };
